// Keep the customer's place when Shopify replaces cart sections.
window.CartAccessibility = {
  capture(container) {
    const active = document.activeElement;
    if (!container.contains(active)) return null;
    const item = active.closest('[data-cart-key]');
    const upsell = active.closest('[data-upsell-product]');
    const rows = [...container.querySelectorAll('[data-cart-key]')];
    const extras = [...container.querySelectorAll('[data-upsell-product]')];
    return {
      active,
      key: item?.dataset.cartKey,
      index: rows.indexOf(item),
      kind: active.closest('cart-remove-button') ? 'remove' : active.name,
      nextProducts: extras.slice(extras.indexOf(upsell) + 1).map(row => row.dataset.upsellProduct),
      upsell: !!upsell,
    };
  },

  restore(container, saved, fallback) {
    if (!saved || container.closest('[inert]')) return;
    // A user may have closed the drawer or moved elsewhere while the request ran.
    if (document.activeElement !== document.body && document.activeElement !== saved.active) return;
    const rows = [...container.querySelectorAll('[data-cart-key]')];
    let target;
    if (saved.upsell) {
      const extras = [...container.querySelectorAll('[data-upsell-product]')];
      target = saved.nextProducts.map(id => extras.find(row => row.dataset.upsellProduct === id))
        .find(Boolean)?.querySelector('.add-upsell-to-cart');
      target ||= container.querySelector('[name="checkout"]');
    } else {
      const row = rows.find(item => item.dataset.cartKey === saved.key) || rows[saved.index] || rows.at(-1);
      target = row?.querySelector(saved.kind === 'remove' ? 'cart-remove-button a' :
        saved.kind === 'plus' || saved.kind === 'minus' ? `button[name="${saved.kind}"]` : '[name="updates[]"]');
    }
    (target || fallback)?.focus({ preventScroll: true });
    target?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
    if (target?.name === 'checkout') this.watchCheckoutFocus(container, target, fallback);
  },

  watchCheckoutFocus(container, target, fallback) {
    // Cart integrations can briefly disable checkout after a section refresh.
    // Respect that lock while keeping focus inside the drawer, then return it.
    this.stopCheckoutWatch?.();
    const stop = () => {
      observer.disconnect();
      clearTimeout(timer);
      document.removeEventListener('focusin', onFocus);
      if (this.stopCheckoutWatch === stop) this.stopCheckoutWatch = null;
    };
    const onFocus = event => {
      if (event.target !== target && event.target !== fallback) stop();
    };
    const observer = new MutationObserver(() => {
      if (container.closest('[inert]') || !target.isConnected) return stop();
      if (target.disabled && document.activeElement === document.body) fallback?.focus({ preventScroll: true });
      else if (!target.disabled && (document.activeElement === fallback || document.activeElement === document.body)) {
        target.focus({ preventScroll: true });
      }
    });
    const timer = setTimeout(stop, 5000);
    observer.observe(target, { attributes: true, attributeFilter: ['disabled'] });
    document.addEventListener('focusin', onFocus);
    this.stopCheckoutWatch = stop;
  },

  announce(container, count, product) {
    const region = container.querySelector('[data-cart-status]');
    if (!region) return;
    const template = product ? region.dataset.added : region.dataset.updated;
    region.textContent = template.replace('[product]', product || '').replace('[count]', count);
  },
};

if (!customElements.get('cart-remove-button')) {
  customElements.define('cart-remove-button', class extends HTMLElement {
    connectedCallback() {
      const link = this.querySelector('a');
      link?.setAttribute('role', 'button');
      this.onclick = event => {
        if (event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const owner = this.closest('cart-notification') || this.closest('cart-items');
        if (!owner?.updateQuantity) return;
        event.preventDefault();
        owner.updateQuantity(this.dataset.index, 0);
      };
      this.onkeydown = event => {
        if (event.key === ' ') { event.preventDefault(); link?.click(); }
      };
    }
  });
}
